import React from 'react';
import './loader-container.scss';
import Spinner from '../spinner/Spinner';
import { Box } from '@mui/material';

export default function LoaderContainer({
  loader,
  children,
  className = '',
  isBox,
  fullHeight,
  boxSx
}) {
  const loaderClass = loader ? 'loader' : '';
  const fullHeightClass = fullHeight ? 'full-height' : '';

  return isBox || boxSx ? (
    loader ? (
      <Box className={`loader-container-center ${loaderClass} ${fullHeightClass}`} sx={boxSx}>
        <Spinner className={className} />
      </Box>
    ) : (
      children
    )
  ) : (
    <>{loader ? <Spinner className={className} /> : children}</>
  );
}
